const LIMIT_APPOINTMENTS_TODAY = 'limit_appointments_per_day';
const MIN_PROFESSIONAL_NUMBER = 'min_professional_number';
const MAX_PROFESSIONAL_NUMBER = 'max_professional_number';
const MAX_FREE_INVOICES_MONTH_PER_PROFESSIONAL =
  'max_free_invoices_month_per_professional';
const MAX_LICENSE = 'max_license';
const MIN_LICENSE = 'min_license';
const PROCEDURE_PACKAGE_MANAGEMENT = 'procedure_package_management';

export {
  LIMIT_APPOINTMENTS_TODAY,
  MIN_PROFESSIONAL_NUMBER,
  MAX_PROFESSIONAL_NUMBER,
  MAX_FREE_INVOICES_MONTH_PER_PROFESSIONAL,
  MAX_LICENSE,
  MIN_LICENSE,
  PROCEDURE_PACKAGE_MANAGEMENT
};
